module.exports = __webpack_public_path__ + "media/images/icons/outlined/user-switch-dbf0e5ac0550c0f1b2dc129ed49330de.svg";